<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height calculators-card">

                <v-tabs v-model="tab">
                    <v-tab>
                        <v-icon left>mdi-view-sequential</v-icon> {{ $t("lumberCalculator") }}
                    </v-tab>
                    <v-tab-item>
                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="calculate"
                                    >
                                        <v-icon>mdi-calculator</v-icon>
                                        <span
                                            v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                        >{{ $t("calculate") }}</span>
                                    </v-btn>
                                </template>
                                <span>{{ $t("calculate") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="reset"
                                    >
                                        <v-icon>mdi-trash-can-outline</v-icon>
                                        <span
                                            v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                        >{{ $t("reset") }}</span>
                                    </v-btn>
                                </template>
                                <span>{{ $t("reset") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-container>
                            <v-layout row wrap mb-2 v-if="calculated">
                                <v-flex xs4>
                                    <p v-if="calcType == '1'"><b>{{$t("amountIn")}} {{volume}} {{$t("m3")}}:</b></p>
                                    <p v-if="calcType == '2'"><b>{{$t("volume")}} {{amount}} {{$t("pieces")}}:</b></p>
                                    <p><b>{{$t("totalWeight")}}:</b></p>
                                    <p><b>{{$t("totalPrice")}}:</b></p>
                                    <p><b>{{$t("totalExpenses")}}:</b></p>

                                    <p><b>{{$t("oneItemVolume")}}:</b></p>
                                    <p><b>{{$t("oneItemWeight")}}:</b></p>
                                    <p><b>{{$t("oneItemPrice")}}:</b></p>
                                    <p><b>{{$t("oneItemExpenses")}}:</b></p>
                                </v-flex>
                                <v-flex xs6>
                                    <p v-if="calcType == '1'">{{Math.ceil(calcAmount)}} {{$t("pc")}}</p>
                                    <p v-if="calcType == '2'">{{calcVolume.toFixed(3)}} {{$t("m3")}}</p>
                                    <p>{{calcWeight.toFixed(2)}} {{$t("kg")}}</p>
                                    <p>{{fullPrice.toFixed(2)}}</p>
                                    <p>{{fullExpenses.toFixed(2)}}</p>

                                    <p>{{itemVolume.toFixed(3)}} {{$t("m3")}}</p>
                                    <p>{{itemWeight.toFixed(2)}} {{$t("kg")}}</p>
                                    <p>{{itemPrice.toFixed(2)}}</p>
                                    <p>{{itemExpenses.toFixed(2)}}</p>
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="calculated"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs8>
                                    <v-radio-group v-model="calcType" :mandatory="false">
                                        <v-radio :label="$t('calculateAmount')" value="1"></v-radio>
                                        <v-radio :label="$t('calculateVolume')" value="2"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs4 pr-3>
                                    <p><b>{{$t("speciesAlt")}}:</b></p>
                                    <v-select
                                        v-model="selectSpecies"
                                        :items="species"
                                        item-text="name"
                                        persistent-hint
                                        return-object
                                        single-line
                                    ></v-select>
                                </v-flex>
                                <v-flex xs4 mt-4 pt-1 pr-3>
                                    <v-text-field
                                        v-model="W"
                                        :label="`${$t('oneM3Weight')}, ${$t('kg')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs8>
                                    <p><b>{{$t("boardsParameters")}}:</b></p>
                                    <v-radio-group v-model="lumberType" :mandatory="false">
                                        <v-radio :label="$t('rectangleCant')" value="1"></v-radio>
                                        <v-radio :label="$t('cylinderCant')" value="2"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="lumberType == '1'">
                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="Tn"
                                        :label="`${$t('thickness')}, ${$t('mm')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="Wn"
                                        :label="`${$t('width')}, ${$t('mm')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        v-model="L"
                                        :label="`${$t('length')}, ${$t('m')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="lumberType == '2'">
                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="D"
                                        :label="`${$t('diameter')}, ${$t('mm')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="L"
                                        :label="`${$t('length')}, ${$t('m')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="price"
                                        :label="`${$t('priceM3')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs4 pr-3>
                                    <v-text-field
                                        v-model="expenses"
                                        :label="`${$t('expensesM3')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="calcType == '1'">
                                <v-flex xs6 pr-3>
                                    <v-text-field
                                        v-model="volume"
                                        :label="`${$t('lumbersVolume')}, ${$t('m3')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="calcType == '2'">
                                <v-flex xs6 pr-3>
                                    <v-text-field
                                        v-model="amount"
                                        :label="`${$t('lumbersAmount')}, ${$t('pc')}`"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card>

            <message-box        ref="MessageBox"/>
            <message-dialog     ref="MessageDialog"/>
            <text-input-dialog  ref="TextInputDialog"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox       from "@/components/dialogs/MessageBox";
    import MessageDialog    from "@/components/dialogs/MessageDialog";
    import TextInputDialog  from "@/components/dialogs/TextInputDialog";

    export default {
        name: "calculatorsForm",

        components: {
            MessageBox,
            MessageDialog,
            TextInputDialog
        },

        data () {
            return {
                alert:         "",
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Калькуляторы", disabled: false },
                ],

                tab: 0,

                loading: {
                    boards:     false,
                    species:    false
                },

                progressBarVisible: false,
                dialogWatcher: null,

                calculated: false,
                calcType: "1",
                selectSpecies:  {},
                species:    [
                    {name: "Береза",        weight: 650},
                    {name: "Ель",           weight: 450},
                    {name: "Кедр",          weight: 440},
                    {name: "Липа",          weight: 500},
                    {name: "Лиственница",   weight: 670},
                    {name: "Осина",         weight: 500},
                    {name: "Пихта",         weight: 450},
                    {name: "Сосна",         weight: 510},
                ],
                lumberType: "1",
                Tn: 25,
                Wn: 100,
                L:  5,
                D:  200,
                W:  0,
                price:      0,
                expenses:   0,
                volume:     0,
                amount:     0,

                fullPrice:  0,
                itemPrice:  0,
                fullExpenses:   0,
                itemExpenses:   0,
                itemVolume: 0,
                itemWeight: 0,
                calcAmount: 0,
                calcVolume: 0,
                calcWeight: 0


            }

        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        watch: {
            selectSpecies:  function() {
                this.W = this.selectSpecies.weight;
                this.calculated = false;
            },

            calcType: function() {
                this.calculated = false;
            },

            lumberType: function() {
                this.calculated = false;
            },
        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();

            this.selectSpecies = this.species[1];

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("calculators"), disabled: false }
                ];

                this.species = [
                    {name: this.$t("birch"),    weight: 650},
                    {name: this.$t("spruce"),   weight: 450},
                    {name: this.$t("cedar"),    weight: 440},
                    {name: this.$t("lime"),     weight: 500},
                    {name: this.$t("larch"),    weight: 670},
                    {name: this.$t("aspen"),    weight: 500},
                    {name: this.$t("fir"),      weight: 450},
                    {name: this.$t("pine"),     weight: 510},
                ];
            },

            reset () {
                this.calculated = false;

                this.calcType = "1";
                this.selectSpecies = this.species[1];
                this.lumberType = "1";
                this.Tn = 0;
                this.Wn = 0;
                this.L  = 0;
                this.D  = 0;
                this.price    = 0;
                this.expenses = 0;
                this.volume   = 0;
                this.amount   = 0;
            },

            calculate () {
                this.calculated = false;

                let volume = parseFloat(this.volume.toString().replace(',','.'));
                let amount = parseFloat(this.amount.toString().replace(',','.'));
                let price = parseFloat(this.price.toString().replace(',','.'));
                let expenses = parseFloat(this.expenses.toString().replace(',','.'));
                let weight = parseFloat(this.W.toString().replace(',','.'));

                let thickness = parseFloat(this.Tn.toString().replace(',','.'));
                let width = parseFloat(this.Wn.toString().replace(',','.'));
                let length = parseFloat(this.L.toString().replace(',','.'));
                let diam = parseFloat(this.D.toString().replace(',','.'));

                if (this.lumberType == "1") {
                    this.itemVolume = (thickness/1000) * (width/1000) * length;
                }
                else if (this.lumberType == "2") {
                    this.itemVolume = (diam/1000) * (diam/1000) * length;
                }

                if (this.calcType == "1") {

                    this.calcAmount = volume / this.itemVolume;
                    this.fullPrice = volume * price;
                    this.fullExpenses = volume * expenses;

                    this.itemPrice = this.itemVolume * price;
                    this.itemExpenses = this.itemVolume * expenses;

                    this.itemWeight = this.itemVolume * weight;
                    this.calcWeight = volume * weight;
                }
                else if (this.calcType == "2") {

                    this.calcVolume = amount * this.itemVolume;
                    volume = this.calcVolume;
                    this.fullPrice = volume * price;
                    this.fullExpenses = volume * expenses;

                    this.itemPrice = this.itemVolume * price;
                    this.itemExpenses = this.itemVolume * expenses;

                    this.itemWeight = this.itemVolume * weight;
                    this.calcWeight = volume * weight;
                }

                this.calculated = true;
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
    .calculators-card
        overflow-y: auto
        max-height: calc(100dvh - 48px)
</style>
